//import { history } from "pixacomHistory"
import axios from "axios";
import moment from "moment-timezone";
import { VscEmptyWindow } from "react-icons/vsc";
import { toast } from "react-toastify";
import storage from "components/Pixacom/storage";
import "react-toastify/dist/ReactToastify.css";

export const startApp = () => {
  return async (dispatch) => {
    var token = storage.getItem("token");
    var config = { headers: { Authorization: `Bearer ${token}` } };

    try {
      let response = await axios.get("/api/Activity/Last", config);
      if (response.status === 200 || response.status === 204) {
        let object = {
          id: response.data.id,
          activityType: response.data.activityType,
          begin: response.data.begin,
          end: response.data.end,
          time: response.data.time,
          taskID: response.data.taskID,
          task: response.data.task,
          activityInterruptionType: response.data.activityInterruptionType,
          activityInterruptionTypeID: response.data.activityInterruptionTypeID,
          feature: response.data.feature,
        };

        if (response.data.activityType === 0) {
          dispatch({
            type: "ACTIVITY_ARRIVAL",
            payload: { lastActivity: object },
          });
        } else if (response.data.activityType === 1) {
          dispatch({
            type: "ACTIVITY_DEPARTURE",
            payload: { lastActivity: object },
          });
        } else if (response.data.activityType === 2) {
          dispatch({
            type: "ACTIVITY_INTERRUPTION",
            payload: { lastActivity: object },
          });
        } else if (response.data.activityType === 3) {
          dispatch({
            type: "ACTIVITY_WORK",
            payload: { lastActivity: object },
          });
        }
      } else {
        console.error("Chyba při načítání dat ze serveru!");
      }
    } catch (err) {
      console.error("Nastala chyba: " + err);
    }
  };
};

const arrivalPost = async () => {
  let object = {
    activityType: 0,
    begin: moment.tz(moment(), "Europe/Prague").format(),
    end: null,
  };

  var token = storage.getItem("token");
  var config = { headers: { Authorization: `Bearer ${token}` } };

  var response = await axios.post("/api/activity/", object, config);
  if (response.status >= 200 && response.status <= 299) {
    return response.data;
  } else {
    toast.error("Chyba při ukládání dat. Záznam nebyl uložen!");
  }
};
export const arrival = () => {
  return async (dispatch) => {
    let activity = await arrivalPost();

    dispatch({
      type: "ACTIVITY_ARRIVAL",
      payload: { atWork: true, lastActivity: activity },
    });
  };
};

export const departure = () => {
  return async (dispatch, getState) => {
    let lastActivity = getState().activity.action.lastActivity;
    let object = {
      activityType: 1,
      begin: null,
      end: moment.tz(moment(), "Europe/Prague").format(),
    };

    if (lastActivity !== null && lastActivity?.activityType === 2) {
      await interruptionEndPost(lastActivity);
    }

    if (lastActivity !== null && lastActivity.activityType === 2) {
      await interruptionEndPost(lastActivity);
    }

    var token = storage.getItem("token");
    var config = { headers: { Authorization: `Bearer ${token}` } };

    var response = await axios.post("/api/activity/", object, config);
    if (response.status >= 200 && response.status <= 299) {
      dispatch({
        type: "ACTIVITY_DEPARTURE",
        payload: { atWork: false, lastActivity: object },
      });
    } else {
      toast.error("Chyba při ukládání dat. Záznam nebyl uložen!");
    }
  };
};

export const interruption = (
  interruptionType,
  startDate,
  endDate,
  lastActivity = null
) => {
  return async (dispatch) => {
    let object = {
      activityType: 2,
      begin: startDate
        ? moment.tz(startDate, "Europe/Prague").format()
        : moment.tz(moment(), "Europe/Prague").format(),
      end: endDate ? moment.tz(endDate, "Europe/Prague").format() : null,
      activityInterruptionTypeID: interruptionType,
      feature: startDate !== undefined && endDate !== undefined,
    };

    if (lastActivity !== null) {
      switch (lastActivity.activityType) {
        case 1:
          await arrivalPost();
          break;
        case 3:
          await endWorkPost(lastActivity);
          break;
      }
    }

    var token = storage.getItem("token");
    var config = { headers: { Authorization: `Bearer ${token}` } };

    var response = await axios.post("/api/activity/", object, config);
    if (response.status >= 200 && response.status <= 299) {
      object = { ...object, id: response.data.id };
      if (!object.feature) {
        dispatch({
          type: "ACTIVITY_INTERRUPTION",
          payload: {
            onInterruption: endDate === undefined,
            lastActivity: response.data,
          },
        });
      }
    } else {
      toast.error("Chyba při ukládání dat. Záznam nebyl uložen!");
    }
  };
};

const interruptionEndPost = async (item) => {
  let object = item;
  object.End = moment.tz(moment(), "Europe/Prague").format();
  object = { ...object, ID: object.id };

  var token = storage.getItem("token");
  var config = { headers: { Authorization: `Bearer ${token}` } };

  var response = await axios.put("/api/activity/" + object.id, object, config);
  if (response.status >= 200 && response.status <= 299) {
    return response.data;
  } else {
    toast.error("Chyba při ukládání dat. Záznam nebyl aktualizován!");
    return null;
  }
};
export const interruptionEnd = (item) => {
  return async (dispatch) => {
    let activity = await interruptionEndPost(item);

    dispatch({
      type: "ACTIVITY_INTERRUPTION_END",
      payload: { lastActivity: activity },
    });
  };
};

export const startWork = (taskID, lastActivity = null) => {
  return async (dispatch) => {
    let object = {
      taskID: taskID,
      activityType: 3,
      begin: moment.tz(moment(), "Europe/Prague").format(),
      end: null,
    };

    if (lastActivity !== null) {
      switch (lastActivity.activityType) {
        case 1:
          await arrivalPost();
          break;
        case 2:
          await interruptionEndPost(lastActivity);
          break;
      }
    }

    var token = storage.getItem("token");
    var config = { headers: { Authorization: `Bearer ${token}` } };

    var response = await axios.post("/api/activity/StartWork/", object, config);
    if (response.status >= 200 && response.status <= 299) {
      dispatch({
        type: "ACTIVITY_WORK",
        payload: { lastActivity: response.data },
      });
    } else {
      toast.error("Chyba při ukládání dat. Záznam nebyl uložen!");
    }
  };
};

function addTimeToFragment(begin, time) {
  var m = moment(time, ["m[m]", "h[h]m[m]", "h[h] m[m]", "h[h]"]);
  return moment
    .tz(
      moment(begin).add(m.hour(), "hours").add(m.minutes(), "minutes"),
      "Europe/Prague"
    )
    .format();
}

const endWorkPost = async (item) => {
  const fragment = {
    begin: item.begin,
    end:
      item.workTime != null
        ? addTimeToFragment(item.begin, item.workTime)
        : moment.tz(moment(), "Europe/Prague").format(),
    note: item.note,
    activityID: item.id,
    taskID: item.taskID,
  };

  let token = storage.getItem("token");
  let config = { headers: { Authorization: `Bearer ${token}` } };
  let response = await axios.put(
    "/api/activity/EndWork/" + fragment.activityID,
    fragment,
    config
  );

  if (response.status >= 200 && response.status <= 299) {
    return response.data;
  } else {
    toast.error("Chyba při ukládání dat. Záznam nebyl aktualizován!");
  }
};
export const endWork = (item) => {
  return async (dispatch) => {
    let activity = await endWorkPost(item);

    dispatch({
      type: "ACTIVITY_WORK_END",
      payload: { lastActivity: activity },
    });
  };
};

const pauseWorkPost = async (lastActivity) => {
  let object = {
    taskID: lastActivity.taskID,
    activityID: lastActivity.id,
    begin: moment.tz(lastActivity.begin, "Europe/Prague").format(),
    end: moment.tz(moment(), "Europe/Prague").format(),
  };

  let token = storage.getItem("token");
  let config = { headers: { Authorization: `Bearer ${token}` } };
  await axios.put("/api/task/pause/" + lastActivity.taskID, null, config);

  let response = await axios.post("/api/activity/fragment", object, config);
  if (response.status === 201) {
    object = lastActivity;
    return object;
  } else {
    toast.error("Chyba při ukládání dat. Záznam nebyl uložen!");
  }
};
export const pauseWork = (lastActivity) => {
  return async (dispatch) => {
    let activity = await pauseWorkPost(lastActivity);

    dispatch({
      type: "ACTIVITY_PAUSE",
      payload: { lastActivity: activity },
    });
  };
};

export const continueWork = (taskID) => {
  return async (dispatch) => {
    let token = storage.getItem("token");
    let config = { headers: { Authorization: `Bearer ${token}` } };
    let activity = await axios.put("/api/task/unpause/" + taskID, null, config);

    let object = {
      taskID: taskID,
      activityID: activity.data,
      begin: moment.tz(moment(), "Europe/Prague").format(),
      end: null,
    };

    let response = await axios.post("/api/activity/fragment", object, config);
    if (response.status === 201) {
      let obj = response.data;
      obj.taskID = taskID;
      obj.begin = object.begin;
      dispatch({
        type: "ACTIVITY_CONTINUE",
        payload: { lastActivity: obj },
      });
    } else {
      toast.error("Chyba při uložení dat!");
    }
  };
};
